export class Geolocator {
    /**
     * Cette classe permet de simplifier la géolocalisation d'un utilisateur.
     * Elle gère la récupération des coordonnées auprès du navigateur et l'envoi
     * à un service de géolocalisation comme Google ou OpenStreetMap
     */
    providerGoogle(){
        return 1;
    }

    providerOpenStreeMap(){
        return 2;
    }

    /**
     * Code exécuté si l'utilisateur refuse la géolocalisation proposée par le navigateur
     */
    geolocationBlocked(error, callbackFail){
        switch(error.code){
            case error.TIMEOUT:
                console.log("La requète de géolocalisation a été stoppée car trop longue");
                break;
            case error.POSITION_UNAVAILABLE:
                console.log("Les informations de position sont indisponible");
                break;
            case error.PERMISSION_DENIED:
                console.log("Vous avez refusé d'être géolocalisé");
                break;
            default:
                console.log("Une erreur de géolocalisation est survenue");
        }

        if ( callbackFail !== undefined ){
            callbackFail(error);
        } else {
            console.log('Pas de callbackFail défini');
        }
    }

    geolocateWithGoogle(position, callbackSuccess){

        let coordinates = position.coords;
        let stringCoordinates = coordinates.latitude+","+coordinates.longitude;

        $.ajax({
            url: "http://maps.googleapis.com/maps/api/geocode/json",
            type: 'get',
            data: {
                sensor: false,
                address: stringCoordinates
            },
        }).done(function (response) {
            if ( callbackSuccess !== undefined ){
                callbackSuccess(response);
            } else {
                console.log('Pas de callbackSuccess défini');
            }
        }).fail(function (error) {
            console.log(error);
        });
    }

    geolocateWithOpenStreetMap(position, callbackSuccess){

        let coordinates = position.coords;
        let stringCoordinates = coordinates.latitude+","+coordinates.longitude;

        $.ajax({
            url: "https://nominatim.openstreetmap.org/search",
            type: 'get',
            data: {
                q: stringCoordinates,
                format: "json",
                addressdetails: 1,
                limit: 1
            }
        }).done(function (response) {
            if ( callbackSuccess !== undefined ){
                callbackSuccess(response);
            } else {
                console.log('Pas de callbackSuccess défini');
            }
        }).fail(function (error) {
            console.log(error);
        });
    }

    /**
     * Recherche les coordonées GPS par rapport à une adresse
     * @param address
     * @param callbackSuccess
     */
    searchPositionWithOpenStreetMap(address, callbackSuccess) {
        address = address.replace(/\,/g, '').replace(/ /g, '+');
        $.ajax({
            url: "https://nominatim.openstreetmap.org/search?format=json&q=" + address,
            type: 'get'
        }).done(function (response) {
            if (callbackSuccess !== undefined) {
                callbackSuccess(response);
            } else {
                console.log('Pas de callbackSuccess défini');
            }
        }).fail(function (error) {
            console.log(error);
        });
    }

    /****** Méthodes pour récupérer des infos spécifiques avec callbacks ******/

    /**
     * Géolocalisation avec l'API Google
     * @requires Service payant requiert une clef d'API avec une
     */
    geolocateUserWithGoogle() {

        // La ligne ci-dessous cherche la position de l'utilisateur et déclenchera la demande d'accord
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                this.geolocateWithGoogle,
                this.geolocationBlocked
            );
        } else {
            console.error("La géolocalisation est n'est pas supportée par ce navigateur web");
        }
    }

    // Géolocalisation avec OpenStreetmap
    geolocateUserWithOsm(callbackSuccess, callbackFail) {

        var geolocationAuthorized = function(position) {
            HegydGeolocator.geolocateWithOpenStreetMap(position, callbackSuccess);
        };

        var geolocationBlocked = function(error) {
            HegydGeolocator.geolocationBlocked(error, callbackFail);
        };

        // La ligne ci-dessous cherche la position de l'utilisateur et déclenchera la demande d'accord
        navigator.geolocation.getCurrentPosition(
            geolocationAuthorized,
            geolocationBlocked
        );
    }

    // Géolocalisation
    geolocateUser(provider, callbackSuccess, callbackFail) {
        switch(provider){
            case this.providerGoogle():
                this.geolocateUserWithGoogle(callbackSuccess, callbackFail);
                break;
            case this.providerOpenStreetMap():
                this.geolocateUserWithOsm(callbackSuccess, callbackFail);
                break;
            default:
                console.log("Pas de correspondance avec un provider connu");
        }
    }

    /**
     * Géolocalisation de l'utilisateur et remplissage du champ identifié avec le ville trouvée
     * @param provider
     * @param targetFieldSelector
     */
    geolocateUserCityToField(provider, targetFieldSelector, callbackSuccess, callbackFail) {

        /**
         * Au chargement de la page en tente de renseigner automatiquement la ville
         * où le visiteur a été géolocalisé
         */
        HegydGeolocator.geolocateUser(
            PROVIDER_OPENSTREETMAP,
            // Callback en cas succès
            function(response){
                // Si la réponse n'est pas vide et qu'il y a une ville, on l'inject
                // dans le champ de recherche
                if (
                    response[0] !== undefined &&
                    response[0]["address"] !== undefined
                ){
                    var city = '';
                    if ( response[0]["address"]["city"] !== undefined ){
                        city = response[0]["address"]["city"];
                        console.info('Use city : '+city);
                    } else if ( response[0]["address"]["town"] !== undefined ) {
                        city = response[0]["address"]["town"];
                        console.info('Use town : '+city);
                    } else if ( response[0]["address"]["village"] !== undefined ) {
                        city = response[0]["address"]["village"];
                        console.info('Use village : '+city);
                    } else {
                        city = response[0]["address"]["county"];
                        console.info('Use county : '+city);
                    }

                    var $field = $(targetFieldSelector);
                    if ( $field !== undefined && $field.length > 0 ){
                        $field.val(city);
                    }
                }
                callbackSuccess(response);
                // $( ".jsSearchShopsButton" ).siblings('.jsSearchButton').trigger('click');

            },
            // Callcback en cas de probleme
            callbackFail
        );
    }
};